import { render, staticRenderFns } from "./LeftYellowLayout.vue?vue&type=template&id=d015cc0a&scoped=true&"
import script from "./LeftYellowLayout.vue?vue&type=script&lang=js&"
export * from "./LeftYellowLayout.vue?vue&type=script&lang=js&"
import style0 from "./LeftYellowLayout.vue?vue&type=style&index=0&id=d015cc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d015cc0a",
  null
  
)

export default component.exports